<template>
  <div>
    <vs-card>
      <div>
        <b-row align-h="end">
          <b-col lg="2" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="listeleTop"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbitis"
              v-model="datepickerbitis"
              :placeholder="placeholderbitis"
              local="en"
              today-variant="danger"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
            />
          </b-col>

          <b-col lg="3" sm="5">
            <b-form-datepicker
              id="datepickerbaslangic"
              v-model="datepickerbaslangic"
              local="en"
              today-variant="danger"
              :placeholder="placeholderbaslangic"
              :start-weekday="weekday"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
              }"
            />
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="cariKarlilik"
              id="button-with-loading-cari"
              class="vs-con-loading__container"
              >Cari Karlılık</vs-button
            >
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              @click="stokKarlilik()"
              color="success"
              type="gradient"
              style="border-radius: 5px; width: 100%"
              >Stok Karlılık</vs-button
            >
          </b-col>
          <b-col style="margin-top: 5px" lg="2" sm="5">
            <vs-button
              @click="stokgrupKarlilik()"
              color="danger"
              type="gradient"
              style="border-radius: 5px; width: 100%"
              >Stok Grup Karlılık</vs-button
            >
          </b-col>
          <b-col style="margin-top: 5px" lg="2" sm="5">
            <vs-button
              @click="personelKarlilik()"
              color="warning"
              type="gradient"
              style="border-radius: 5px; width: 100%"
              >Personel Karlılık</vs-button
            >
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <vs-card v-if="turKontrol">
      <div slot="header">
        <h3>{{ turDegeri }}</h3>
      </div>
      <div v-if="turDegeri == 'Personel Karlılık'">
        <ag-grid-vue
          style="width: 100%; height: 450px; margin-top: 25px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefsPersonel"
          :rowData="rowDataPersonel"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
      <div v-if="turDegeri == 'Stok Grup Karlılık'">
        <ag-grid-vue
          style="width: 100%; height: 450px; margin-top: 25px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefsStokgrup"
          :rowData="rowDataStokgrup"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
      <div v-if="turDegeri == 'Stok Karlılık'">
        <ag-grid-vue
          style="width: 100%; height: 450px; margin-top: 25px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefsStok"
          :rowData="rowDataStok"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
      <div v-if="turDegeri == 'Cari Karlılık'">
        <ag-grid-vue
          style="width: 100%; height: 450px; margin-top: 25px"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefsCari"
          :rowData="rowDataCari"
          :localeText="localeText"
          @grid-ready="onGridReady"
          @first-data-rendered="onFirstDataRendered"
        >
        </ag-grid-vue>
      </div>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import CariKarlilikDetayButon from "../components/crm-components/finans-components/CariKarlilikDetayButon.vue";
export default {
  components: {
    AgGridVue,
    CariKarlilikDetayButon
  },
  data() {
    return {
      weekday:1,
      columnDefsCari: null,
      rowDataCari: null,
      columnDefsPersonel: null,
      rowDataPersonel: null,
      columnDefsStokgrup: null,
      rowDataStokgrup: null,
      columnDefsStok: null,
      rowDataStok: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      turKontrol: false,
      turDegeri: "",
      datepickerbitis: "",
      placeholderbitis: "",
      datepickerbaslangic: "",
      placeholderbaslangic: "",
      arananDeger: "",
      localeText: null
    };
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    personelKarlilik() {
      this.turKontrol = true;
      this.turDegeri = "Personel Karlılık";
    },
    stokgrupKarlilik() {
      this.turKontrol = true;

      this.turDegeri = "Stok Grup Karlılık";
    },
    stokKarlilik() {
      this.turKontrol = true;

      this.turDegeri = "Stok Karlılık";
    },
    cariKarlilik() {
      this.turKontrol = true;

      this.turDegeri = "Cari Karlılık";
    },
    listeleTop() {}
  },
  beforeMount() {
    this.columnDefsCari = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "CariKarlilikDetayButon"
      },
      {
        headerName: "Cari No",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Parça Ad",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Maliyet",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar %",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefsPersonel = [
      {
        headerName: "Stok Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Parça Ad",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Maliyet",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar %",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefsStokgrup = [
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Parça Ad",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Maliyet",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar %",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
    this.columnDefsStok = [
      {
        headerName: "Personel Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Parça Ad",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Tutar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Maliyet",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kar %",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }
    ];
  }
};
</script>
